import { Locale } from '@ps-smart-cp/ppfw-client';
import { enumToName, rawValueToEnum } from '../utils';

/** ターゲット実行ステータス */
enum TargetExecutionStatus {
  executing = 'EXECUTING',
  completed = 'COMPLETED',
  failed = 'FAILED',
  stopped = 'STOPPED',
  partialError = 'PARTIAL_FAILURE',
}

const nameConfig = {
  executing: new Map([[Locale.ja, '実行中']]),
  completed: new Map([[Locale.ja, '正常終了']]),
  failed: new Map([[Locale.ja, '失敗']]),
  stopped: new Map([[Locale.ja, '中止']]),
  partialError: new Map([[Locale.ja, '一部失敗']]),
};

const toEnum = rawValueToEnum(TargetExecutionStatus, TargetExecutionStatus.executing);
const toDisplay = enumToName(TargetExecutionStatus, nameConfig);

export const targetExecutionStatus = {
  enum: TargetExecutionStatus,
  nameConfig,
  toDisplay,
  toEnum,
};
export type { TargetExecutionStatus };
